import { render, staticRenderFns } from "./PlayerOptions.vue?vue&type=template&id=5f8ca8f5&scoped=true&"
import script from "./PlayerOptions.vue?vue&type=script&lang=js&"
export * from "./PlayerOptions.vue?vue&type=script&lang=js&"
import style0 from "./PlayerOptions.vue?vue&type=style&index=0&id=5f8ca8f5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f8ca8f5",
  null
  
)

export default component.exports